<template>
    <b-col>
    <basic-update-form></basic-update-form>
    </b-col>
</template>

<script>
  import BasicUpdateForm from '@/components/applicant/basic/BasicUpdateForm'
    export default {
        name: "Index",
        components:{
          BasicUpdateForm
        },
    }
</script>

<style scoped>

</style>
